import * as React from "react"

const SvgPlay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 17.746V7.396q0-.424.3-.712a.98.98 0 0 1 .962-.25q.138.037.263.112l8.15 5.175q.225.15.337.375a1.05 1.05 0 0 1 0 .95.97.97 0 0 1-.337.375l-8.15 5.175a1.04 1.04 0 0 1-.525.15.98.98 0 0 1-.7-.287.95.95 0 0 1-.3-.713m2-1.825 5.25-3.35L10 9.221z" />
  </svg>
)
export default SvgPlay
